import React, {Component} from 'react';
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { renderField, required, renderCheckbox, renderTextArea} from "../../../utils/formValidations.js";
import { withRouter } from "react-router-dom";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, Alert, Input, InputGroup, InputGroupAddon } from "reactstrap";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import {getOidcConfigs } from "../../../actions/actionOidc";
import { getLicenseStatus} from "../../../actions/actionFooter";


class OidcConfigFormTemplate extends Component {
    constructor (props){
        super(props);
        this.state = {
            currentOidc: {},
            collapseAdvanced: false,
            urlField: "",
            licensed: false,
            redirect_url: "https://" + window.location.host + "/api/oidc_callback",
        };
        this.submitApi = this.submitApi.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.handleCreateError = this.handleCreateError.bind(this);
        this.handleUpdateError = this.handleUpdateError.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.handleUrlChange = this.handleUrlChange.bind(this);
        this.toggleAdvanced = this.toggleAdvanced.bind(this);
    }

    toggleAdvanced() {
        this.setState({collapseAdvanced: !this.state.collapseAdvanced})
    }


    submitApi(userData) {
        userData.redirect_url = this.state.redirect_url;
        if (this.props.fromUpdate) {
            userData.oidc_config_id = this.state.currentOidc && this.state.currentOidc.oidc_config_id;
            this.props.updateOidcConfig(userData)
                .then(() => this.handleUpdateSuccess())
                .catch(() => this.handleUpdateError());
        }else {
            this.props.createOidcConfig(userData)
                .then(() => this.handleCreateSuccess())
                .catch(() => this.handleCreateError());
        }
    }

    handleUpdateSuccess(){
        const {updateOidcError} = this.props;
        if(updateOidcError){
            NotificationManager.error(updateOidcError,"Update OIDC Config", 3000);
        }
        else{
            NotificationManager.success("OIDC Config Updated", "Successfully Updated OIDC Config");
            this.props.history.push("/oidc");
        }
    }

    handleUpdateError(){
        const {updateOidcError} = this.props;
        if(updateOidcError){
            NotificationManager.error(updateOidcError,"Update OIDC Config", 3000);
        } else
            NotificationManager.error("Update OIDC Config Failed", "Update OIDC Config", 3000);
    }

    handleCreateSuccess(){
        const {createOidcError} = this.props;
        if(createOidcError){
            NotificationManager.error(createOidcError,"Create OIDC Config", 3000);
        }
        else{
            NotificationManager.success("OIDC Config Created", "Successfully Created OIDC Config");
            this.props.history.push("/oidc");
        }
    }
    handleUrlChange(e) {
        this.setState({urlField: e.target.value});
    }

    handleCreateError(){
        const {createOidcError} = this.props;
        if(createOidcError){
            NotificationManager.error(createOidcError,"Create OIDC Config", 3000);
        } else
            NotificationManager.error("Create OIDC Config Failed","Create OIDC Config", 3000);
    }

    cancelButton(){
        this.props.history.push("/oidc");
    }


    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.oidc_configs && nextProps.oidc_configs.length > 0 && this.props.oidc_configs !== nextProps.oidc_configs && this.props.getOidcLoading && this.props.fromUpdate){
            let currentOidc = nextProps.oidc_configs.find(oidc => oidc.oidc_id === this.props.oidcConfigId);
            this.setState({currentOidc: currentOidc, urlField : currentOidc && currentOidc.key ? currentOidc.key : ''});
            this.props.initialize({
                auth_url: currentOidc.auth_url,
                auto_login: currentOidc.auto_login,
                scope: currentOidc.scope ? currentOidc.scope.join('\n') : '',
                client_id: currentOidc.client_id,
                client_secret: currentOidc.client_secret,
                display_name: currentOidc.display_name,
                enabled: currentOidc.enabled,
                hostname: currentOidc.hostname,
                is_default: currentOidc.is_default,
                oidc_id: currentOidc.oidc_id,
                redirect_url: currentOidc.redirect_url,
                token_url: currentOidc.token_url,
                user_info_url: currentOidc.user_info_url,
                logo_url: currentOidc.logo_url,
                username_attribute: currentOidc.username_attribute,
                groups_attribute: currentOidc.groups_attribute,
                debug: currentOidc.debug,
            });
        }
    }

    componentDidMount() {
        if (this.props.fromUpdate) {
            this.props.getOidcConfigs();
        }
        this.props.getLicenseStatus()
            .then(() => {
                const {license_info} = this.props;
                if (license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('saml') >= 0 ){
                    this.setState({licensed: true});
                }
            });

    }


    render() {
        const {handleSubmit} = this.props;
        const {redirect_url } = this.state;

         if (!this.state.licensed){
            let license_url = `${__LICENSE_INFO_URL__}`;
            return (
                <Alert color="none" isOpen={true}>
                    <h4>Unavailable</h4>
                    This feature must be licensed.
                    <hr />
                    <a href={license_url}>More Information</a><br/>
                </Alert>
            )
        }


        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="display_name" className="requiredasterisk">Display Name </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="display_name"
                                       id="display_name"
                                       component={renderField}
                                       validate={required}
                                />

                            </Col>
                        </Row>
                    </FormGroup>
                     <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="logo_url">Logo URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="logo_url"
                                       id="logo_url"
                                       component={renderField}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="enabled">Enabled</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="enabled">
                                    <Field type ="checkbox"
                                        name="enabled"
                                        id="enabled"
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="auto_login">Auto Login</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="auto_login">
                                    <Field type ="checkbox"
                                        name="auto_login"
                                        id="auto_login"
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="hostname">Hostname </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="hostname"
                                       id="hostname"
                                       component={renderField}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="is_default">Default</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="is_default">
                                    <Field type ="checkbox"
                                        name="is_default"
                                        id="is_default"
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="client_id" className="requiredasterisk">Client ID </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="client_id"
                                       id="client_id"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="client_secret" className="requiredasterisk">Client Secret </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="password"
                                       name="client_secret"
                                       id="client_secret"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="auth_url" className="requiredasterisk">Authorization URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="auth_url"
                                       id="auth_url"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="auth_url" className="requiredasterisk">Token URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="token_url"
                                       id="token_url"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="user_info_url" className="requiredasterisk">User Info URL </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="user_info_url"
                                       id="user_info_url"
                                       component={renderField}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="scope" className="requiredasterisk">Scope (One Per Line)</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="textarea"
                                       name="scope"
                                       id="scope"
                                       component={renderTextArea}
                                       validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="username_attribute" className="requiredasterisk">Username Attribute </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="username_attribute"
                                       id="username_attribute"
                                       component={renderField}
                                       validate={required}
                                />

                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="groups_attribute">Groups Attribute </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                       name="groups_attribute"
                                       id="groups_attribute"
                                       component={renderField}
                                />

                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="debug">Debug</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="debug">
                                    <Field type ="checkbox"
                                        name="debug"
                                        id="debug"
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="5">
                                <Label>Redirect URL</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <InputGroup>
                                    <Input
                                        readOnly
                                        value={redirect_url} />
                                    <InputGroupAddon addonType="append">
                                        <Button
                                            onClick={() => this.copyToClipboard(redirect_url)}>
                                            <i className = "fa fa-copy" aria-hidden="true"></i>
                                        </Button>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" 
                        className="cancel-button"
                        size="sm" color="basic" onClick={() => this.cancelButton()}>Cancel</Button>
                        <Button type="submit" size="sm"
                        className="submit-button" 
                        color="primary">
                            Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

OidcConfigFormTemplate.proptypes = {
    createOidcConfig: Proptypes.func,
    updateOidcConfig: Proptypes.func,
    fromUpdate: Proptypes.bool,
};

let OidcConfigFormWithRouter = withRouter(OidcConfigFormTemplate);


const selector = formValueSelector('OidcConfigForm');

let OidcConfigForm =  connect(state =>{

            const has_allow_anonymous = selector(state, 'allow_anonymous');
            const has_limit_sessions = selector(state, 'limit_sessions');
            const has_limit_ips = selector(state, 'limit_ips');

            return {
                has_allow_anonymous,
                has_limit_sessions,
                has_limit_ips,
                createOidcError: state.oidc.createOidcError,
                createOidcLoading: state.oidc.createOidcLoading,
                createdOidc: state.oidc.createdOidc,
                updateOidcError: state.oidc.updateOidcError,
                updateOidcLoading: state.oidc.updateOidcLoading,
                updatedOidc: state.oidc.updatedOidc,
                oidc_configs: state.oidc.oidc_configs,
                getOidcLoading: state.oidc.getOidcLoading || false,
                oidcFormValues: state.form && state.form.OidcConfigForm && state.form.OidcConfigForm.values ? state.form.OidcConfigForm.values : null,
                license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,

            }
    },

    dispatch =>
        ({
            getOidcConfigs: () => dispatch(getOidcConfigs()),
            getLicenseStatus: () => dispatch(getLicenseStatus()),
        }))(OidcConfigFormWithRouter);

export default reduxForm({
    form: "OidcConfigForm",
})(OidcConfigForm);